/* eslint-disable react/jsx-no-bind */
/* eslint-disable */

import useRoles from "customHooks/useRoles";
import React, { useState } from "react";
import {
  Search,
  ShoppingBag,
  Trello,
  Users,
  GitPullRequest,
  FileText,
  BookOpen,
  BarChart2 
} from "react-feather";
import { NavLink, useLocation } from "react-router-dom";
import {
  handleChangeSidebarState,
  useResponsive,
} from "context/responsiveContext";
import { Dropdown } from "react-bootstrap";
import { useAuth, handleLogout } from "context/auth";

const isActiveLink = ({ isActive }) => (isActive ? "active link" : " link");
const isActiveDropdown = (isActive) =>
  isActive ? "active sidebar__dropdown" : " sidebar__dropdown";

function Sidebar() {
  const location = useLocation();
  const isReports = location.pathname.match(/reports/);
  const isUsers = location.pathname.match(/users/);
  const isDashboard = location.pathname.match(/dashboard/);
  const [auth, authDispatch] = useAuth();
  const { roles, permissions } = useRoles();
  const [responsiveState, dispatchResponsive] = useResponsive();
  const { sidebarClass } = responsiveState;

  const OpenNewPage = (url) => {
    window.open(url, '_blank');
  };

  return (
    <>
        <aside className={`sidebar ${sidebarClass}`}>
      <ul>
        <li>
          <NavLink
            onClick={handleChangeSidebarState.bind(this, dispatchResponsive, {
              sidebarClass: responsiveState.sidebarClass,
            })}
            to="/"
            className={isActiveLink}
          >
            {roles.people ? (
              <>
                <Trello />
                <span className="sidebar__text">
                  <span>الأراضي الخاصة بي</span>
                </span>
              </>
            ) : (
              <>
                <Search />
                <span className="sidebar__text">
                  <span>بحث الأراضي</span>
                </span>
              </>
            )}
          </NavLink>
        </li>
        {permissions.employeeWithChangeRequests && (
          <li>
            <NavLink
              onClick={handleChangeSidebarState.bind(this, dispatchResponsive, {
                sidebarClass: responsiveState.sidebarClass,
              })}
              to="/changezone"
              className={isActiveLink}
            >
              <GitPullRequest />
              <span className="sidebar__text">
                <span>تغيير صفة الاستعمال</span>
              </span>
            </NavLink>
          </li>
        )}
        {roles.people && (
          <li>
            <NavLink
              onClick={handleChangeSidebarState.bind(this, dispatchResponsive, {
                sidebarClass: responsiveState.sidebarClass,
              })}
              to="/search"
              className={isActiveLink}
            >
              <Search />
              <span className="sidebar__text">
                <span>بحث الأراضي</span>
              </span>
            </NavLink>
          </li>
        )}
        {(roles.people ||
          permissions.employeeWithChangeRequests ||
          roles.manager) && (
          <li>
            <NavLink
              onClick={handleChangeSidebarState.bind(this, dispatchResponsive, {
                sidebarClass: responsiveState.sidebarClass,
              })}
              to="/requests"
              className={isActiveLink}
            >
              <ShoppingBag />
              <span className="sidebar__text">
                {roles.employeeOrPeople && <span>طلباتي</span>}
                {roles.manager && <span>الطلبات</span>}
              </span>
            </NavLink>
          </li>
        )}
        {(roles.systemAdminOrManager || permissions.employeeWithReports) && (
          <li>
            <div
              className={
                isReports ? isActiveDropdown(true) : isActiveDropdown(false)
              }
            >
              <span className="link">
                <FileText />
                <span className="sidebar__text">
                  <span>تقارير</span>
                </span>
              </span>

              {(roles.systemAdminOrManager ||
                permissions.employeeWithRegulationPlansReport) && (
                <NavLink
                  onClick={handleChangeSidebarState.bind(
                    this,
                    dispatchResponsive,
                    {
                      sidebarClass: responsiveState.sidebarClass,
                    }
                  )}
                  to="/reports/1"
                  relative="1"
                  className={isActiveLink}
                >
                  <span className="sidebar__text">
                    <span>عمليات اصدار المخططات</span>
                  </span>
                </NavLink>
              )}

              {roles.systemAdmin && (
                <NavLink
                  onClick={handleChangeSidebarState.bind(
                    this,
                    dispatchResponsive,
                    {
                      sidebarClass: responsiveState.sidebarClass,
                    }
                  )}
                  to="/reports/2"
                  className={isActiveLink}
                >
                  <span className="sidebar__text">
                    <span>متابعة حركات المستخدمين</span>
                  </span>
                </NavLink>
              )}
              {(roles.systemAdminOrManager ||
                permissions.employeeWithPaymentReport) && (
                <NavLink
                  onClick={handleChangeSidebarState.bind(
                    this,
                    dispatchResponsive,
                    {
                      sidebarClass: responsiveState.sidebarClass,
                    }
                  )}
                  to="/reports/3"
                  className={isActiveLink}
                >
                  <span className="sidebar__text">
                    <span>الإرسالية المالية</span>
                  </span>
                </NavLink>
              )}
              {(roles.systemAdminOrManager ||
                permissions.employeeWithDashboardReport) && (
                <NavLink
                  onClick={handleChangeSidebarState.bind(
                    this,
                    dispatchResponsive,
                    {
                      sidebarClass: responsiveState.sidebarClass,
                    }
                  )}
                  to="/reports/4"
                  className={isActiveLink}
                >
                  <span className="sidebar__text">
                    <span>لوحة المعلومات</span>
                  </span>
                </NavLink>
              )}
              {(roles.systemAdminOrManager ||
                permissions.employeeWithDashboardReport) && (
                <NavLink
                  onClick={handleChangeSidebarState.bind(
                    this,
                    dispatchResponsive,
                    {
                      sidebarClass: responsiveState.sidebarClass,
                    }
                  )}
                  to="/reports/5"
                  className={isActiveLink}
                >
                  <span className="sidebar__text">
                    <span>لوحة الغاء القفل</span>
                  </span>
                </NavLink>
              )}
            </div>
          </li>
        )}        

        {(roles.systemAdmin) && (
          <li>
            <div
              className={
                isDashboard ? isActiveDropdown(true) : isActiveDropdown(false)
              }
            >
              <span className="link">
                <BarChart2 />
                <span className="sidebar__text">
                  <span>لوحة المؤشرات</span>
                </span>
              </span>

              <NavLink
                  onClick={handleChangeSidebarState.bind(
                    this,
                    dispatchResponsive,
                    {
                      sidebarClass: responsiveState.sidebarClass,
                    }
                  )}
                  to={`/dashboard/1?url=${process.env.REACT_APP_DASHBOARD_ONE}`}
                  relative="1"
                  className={isActiveLink}
                >
                  <span className="sidebar__text">
                    <span>عدد المخططات التجريبية و الفعلية</span>
                  </span>
                </NavLink>

                <NavLink
                  onClick={handleChangeSidebarState.bind(
                    this,
                    dispatchResponsive,
                    {
                      sidebarClass: responsiveState.sidebarClass,
                    }
                  )}
                  to={`/dashboard/2?url=${process.env.REACT_APP_DASHBOARD_TWO}`}
                  className={isActiveLink}
                >
                  <span className="sidebar__text">
                    <span>احصائيات المخططات</span>
                  </span>
                </NavLink>

            </div>
          </li>
        )}        
        {roles.systemAdmin && (
          <li>
            <div
              className={
                isUsers ? isActiveDropdown(true) : isActiveDropdown(false)
              }
            >
              <span className="link">
                <Users />
                <span className="sidebar__text">
                  <span>المستخدمين</span>
                </span>
              </span>
              <NavLink
                onClick={handleChangeSidebarState.bind(
                  this,
                  dispatchResponsive,
                  {
                    sidebarClass: responsiveState.sidebarClass,
                  }
                )}
                to="/users/employees"
                relative="1"
                className={isActiveLink}
              >
                <span className="sidebar__text">
                  <span>الموظفين</span>
                </span>
              </NavLink>
              <NavLink
                onClick={handleChangeSidebarState.bind(
                  this,
                  dispatchResponsive,
                  {
                    sidebarClass: responsiveState.sidebarClass,
                  }
                )}
                to="/users/people"
                className={isActiveLink}
              >
                <span className="sidebar__text">
                  <span>المواطنين</span>
                </span>
              </NavLink>
            </div>
          </li>
        )}
        {roles.people && (
          <li>
            <a
              href={`${process.env.PUBLIC_URL}/Petra-Citizen-User-Manual.pdf`}
              download
              className="link"
              target="_blank"
              rel="noreferrer"
            >
              <BookOpen />
              <span className="sidebar__text">
                <span>دليل المستخدم</span>
              </span>
            </a>
          </li>
        )}
        <li>
          <Dropdown>
            <Dropdown.Toggle
              className="dropdown-basic-user-info"
              style={{
                width: "100%",
                backgroundColor: "var(--primary)",
                borderColor: "var(--primary)",
                fontSize: "17.7px ",
              }}
            >
              <span>
                أهلا ..{" "}
                {auth?.userDetails?.details?.fullName?.trim() ||
                  auth?.userDetails?.details?.userName}
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                onClick={() => handleLogout(authDispatch, roles.people)}
                className="text-center"
              >
                تسجيل خروج
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </li>
      </ul>

    </aside>
    </>
  );
}

export default Sidebar;
